<template>
  <div class="mall-cart-empty">
    <MallBasketIcon :size="100" />
    <div class="mall-cart-empty__text">
      <span class="typo-lg-semi">장바구니가 비었어요</span>
    </div>
  </div>
</template>

<script>
import MallBasketIcon from '@/components/new/atoms/MallBasketIcon.vue'

export default {
  name: 'MallCartEmpty',
  components: {
    MallBasketIcon,
  },
}
</script>

<style scoped>
/* Figma Contents 영역(184px) 높이 고정 - 화면 세로 가운데 정렬 기준 */
.mall-cart-empty {
  display: flex;
  width: 100%;
  height: 184px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.mall-cart-empty__text {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallCartEmpty.vue